import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import Block from '@views/components/block/Block';
import Widget from '@views/components/widget/Widget';
import ListInline from '@views/components/list/ListInline';
import { FILTER } from '../../intl';
import { OrderType } from '../../const';

interface HeaderFilterProps {
  activeOrder?: string;
  onFilter: (params: any) => void;
}

const Link = styled.a`
  cursor: pointer;
`;

const ORDER_LIST = [
  'BEST_SELLER',
  'POPULAR',
  'HIGH_PRICE',
  'LOW_PRICE',
];

export const HeaderFilter: FunctionComponent<HeaderFilterProps> = ({
  activeOrder = OrderType.BEST_SELLER,
  onFilter,
}) => (
  <Block.Header className="mb-3">
    <Block.Title></Block.Title>
    <Widget.Filter className="justify-content-lg-end">
      <ListInline filterList filteredCategory>
        {Array.prototype.map.call(
          ORDER_LIST,
          (item: string): JSX.Element => (
            <ListInline.Item
              key={item}
              active={activeOrder === OrderType[item]}
            >
              <Link
                className="list-inline__link"
                onClick={() => onFilter({ orderBy: OrderType[item] })}
              >
                {FILTER[item]}
              </Link>
            </ListInline.Item>
          )
        )}
      </ListInline>
    </Widget.Filter>
  </Block.Header>
);

export default HeaderFilter;
